export const GETSTREAM_STATUS = '[GETSTREAM] SET CLIENT STATUS';
export const GETSTREAM_SET_CLIENT = '[GETSTREAM] SET CLIENT';

export function setGetStreamClient(client) {
	return {
		type: GETSTREAM_SET_CLIENT,
		client,
	};
}

export function setGetStreamClientStatus(status) {
    return {
        type: GETSTREAM_STATUS,
        status,
    };
}